<div class="product-card mb-4 mt-4">
  <h4 class="text-center lh-1 font-17">
    You can now visit any of our products
  </h4>
  <div class="product-actions d-flex gap-3 justify-content-center">
    <button class="btn btn-outlined" (click)="trackButtonClick('Vet Times'); goToProduct('Vet Times')">Vet Times</button>
    <button class="btn btn-outlined" (click)="trackButtonClick('Vet Times jobs'); goToProduct('Vet times jobs')">Vet Times jobs</button>
    <button class="btn btn-outlined" (click)="trackButtonClick('CPD+'); goToProduct('CPD')">CPD</button>
  </div>
</div>
